let getAccessTokenSilently = null;

export const auth0 = {
  getAccessTokenSilently: () => getAccessTokenSilently,
  setGetAccessTokenSilently: func => {
    getAccessTokenSilently = func;
  },
};
